<template>
  <div style="background-color: #fff">
    <div class="flex-center">
      <div class="nectar-video-inner">
        <div
          class="row-bg-overlay row-bg-layer"
          style="background-color: #000000; opacity: 0.3"
        ></div>
        <div
          class="nectar-video-bg"
          width="100%"
          height="auto"
          preload="auto"
          loop=""
          autoplay=""
          muted=""
          playsinline=""
          style="
            visibility: visible;
            width: 100%;
            height: 100%;
            object-fit: cover;
          "
        >
          <img
            style="width: 100%; height: 125%"
            src="../assets/2024/04/BI.jpg"
            alt=""
          />
        </div>
        <div class="video-content">
          <div class="video-content-left">
            <div class="wenzhang"  @click.stop="gotoarticle('companypages')">Company News & Blogs</div>
            <p class="video-content-title">
        Business Intelligence Can Upgrade Marketing Strategies and Improve ROI!
            </p>
            <p style="text-align: center; margin-top: 20px">
              <span class="Financial-text">April 26, 2024</span
              ><span class="Financial-text">No Comments</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="fincal-content">
      <p class="fincal-head" style="margin-left:-13%">
        <a class="fincalrouter" href="">Home</a> » The Importance of User Experience in Business
      </p>
      <div class="fincal-wenzi fincal-head">
    Business intelligence (BI) platforms can be a game-changer for marketers by offering a data-driven approach to strategizing and measuring campaigns. Here’s how BI platforms can provide insights that lead to positive ROI:
      </div>
     <div class="fincal-wenzi fincal-head">
          <b>Understanding Your Audience: </b>
        BI tools can analyze customer data from various sources, like website behavior, demographics, and purchase history. This will paint a detailed picture of your ideal customer profile and preferences. With this insight, marketers can tailor messaging, personalize content, and target the right audience segments for maximum impact.
      </div>
        <div class="fincal-wenzi fincal-head">
            <b>Optimizing Campaigns: </b>
             BI platforms track key performance indicators (KPIs) across different marketing channels. This allows you to see which campaigns generate leads, drive conversions, and deliver the best return on ad spend (ROAS). By analyzing this data, you can identify what’s working and what’s not, allowing you to optimize campaigns in real time and allocate resources more effectively.
      </div>
    <div class="fincal-wenzi fincal-head">
          <b>Identifying Trends And Opportunities: </b>
        BI can reveal hidden trends in customer behavior and market data. For instance, you might discover a surge in demand for a particular product or a growing interest in a specific content theme. This foresight enables you to capitalize on opportunities and stay ahead of the curve with marketing strategies.
      </div>
        <div class="fincal-wenzi fincal-head">
                  <b>Competitive Analysis </b>
                   BI tools can gather information on competitors’ marketing strategies and market positioning. Data can be analyzed to determine strengths and weaknesses, spot gaps in the market, and develop strategies to differentiate yourself to gain a competitive edge.
      </div>
      <div class="fincal-wenzi fincal-head">
               <b>Improved Decision-Making:</b>
               BI replaces guesswork with data-driven insights. Marketers can make informed decisions about budget allocation, campaign adjustments, and new marketing initiatives based on concrete evidence, leading to an improved chance of success and maximizing ROI.
      </div>
          <div class="fincal-wenzi fincal-head">
            In summary, BI platforms empower marketers to target the right audience, optimize campaigns for better performance, and identify trends and opportunities with data-driven decisions. This comprehensive approach leads to improved marketing strategies that deliver a positive return on investment for businesses.
      </div>
     

    </div>
    <div class="flex-center nextewnzheng">
      <div class="nectar-video-inner nectar-video-innertwo">
        <div
          class="row-bg-overlay row-bg-layertwo"
          style="background-color: #000000; opacity: 0.3"
        ></div>
        <!-- <div
          class="nectar-video-bgtwo"
          width="100%"
          height="auto"
          preload="auto"
          loop=""
          autoplay=""
          muted=""
          playsinline=""
          style="
            visibility: visible;
            width: 100%;
            height: 100%;
            object-fit: cover;
          "
        >
          <img
          class="imgscale"
            style="width: 100%; height: 100%"
            src="../assets/2024/05/Downloader.la-664234ed94f66.jpg"
            alt=""
          />
        </div> -->
        <div class="video-content">
          <div class="video-content-left" style="top: 33%">
            <div class="wenzhangtwo" @click="gotoarticle('intelligence')">Next Post</div>
            <p style="font-size: 47px; color: #fff">
          Simplify Your Daily Life with Business Intelligence
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Products",
  data() {
    return {};
  },
  watch: {
    //   '$route.hash': function() {
    //     // 在这里可以处理hash变化后的逻辑
    //   this.scrollToAnchor()
    //   }
  },
  methods: {
    //  scrollToAnc
         gotoarticle(route){
      console.log(route);
    this.$router.push({ name: route });
          // window.location.hash = "#about#top";
    }
    //   const el = document.querySelector(this.$route.hash);
    //   el.scrollIntoView({ behavior: "smooth" });
    // },
  },
  mounted() {
 window.scrollTo(0, 0)
    // this.scrollToAnchor()
  },
};
</script>

<style scoped>
ol,
ul {
  margin-left: 30px;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.nectar-video-inner {
  width: 100%;
  position: relative;
  height: 610px;
}
.row-bg-layer {
  position: absolute;
  width: 100%;
  height: 610px;
  z-index: 9;
}
.row-bg-layertwo {
  position: absolute;
  width: 100%;
  height: 390px;
  z-index: 9;
}
.video-content {
  /* z-index: 10; */
  width: 100%;
  display: flex;
  justify-content: center;
  /* position: relative; */
}
.postion {
  position: absolute;
  top: 26%;
  right: 19%;
  width: 25%;
  z-index: 11;
}
.video-content-title {
  font-size: 81px;
  color: #fff;
  margin-bottom: 0px;
  width: 83%;
  margin: auto;
  text-align: center;
}
.video-content-left {
  position: absolute;
  z-index: 11;
  top: 26%;
  text-align: center;
}
.start_font {
  font-family: "AlegreyaSans-Medium";
  font-size: 61px;
  width: auto;
  color: #1290c9;
  text-align: left;
  font-style: normal;
  position: relative;
  display: inline-block;
  z-index: 10;
}
.focus {
  position: relative;
}
h2 {
  font-family: Alegreya Sans;
  font-size: 46px;
  line-height: 56px;
  font-weight: 500;
  margin: 7px 0px;
}

head {
}
h3 {
  font-family: Alegreya Sans;
  font-size: 28px;
  line-height: 38px;
  font-weight: 500;
  /* color: #3d7cbf; */
  text-align: left;
  margin-bottom: 8px;
  margin-top: 10px;
}
.nectar-video-bg {
  height: 100%;
  position: relative;
  top: -25%;
}
.Financial-text {
  padding: 0 20px;
  border-left: 1px solid #ccc;
  color: #fff;
}
.fincalrouter {
  color: #1290c9;
}
.fincal-content {
  margin: auto;
  width: 69%;
  padding: 80px 0px;
  font-size: 18px;
}
.fincal-head {
  padding-bottom: 27px;
}
.fincal-wenzi {
  font-family: Roboto;
  font-size: 18px;
  line-height: 32px;
  font-weight: 400;
}
.wenzhang {
  color: #fff;
  padding: 6px;
  font-size: 14px;
  border: 1px solid #ccc;
  width: 200px;
  margin: auto;
  margin-top: -50px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.wenzhangtwo {
  color: #fff;
  padding: 6px;
  font-size: 18px;
  margin: auto;
}
.nectar-video-innertwo {
  height: 390px;
  background-image: url("../assets/2024/04/Business-Intelligence-BI-1.jpg");
  background-position-y: 501px;
  transition: transform 0.42s ease;
      background-size: 100%;
}
.nextewnzheng {
  overflow: hidden;
}
.nextewnzheng {
  transition: transform 0.42s ease;
}

.nextewnzheng:hover .nectar-video-innertwo {
  cursor: pointer;
  transform: scale(1.1);
  transition: transform 0.42s ease;
}
.nextewnzheng :hover .row-bg-layertwo {
  opacity: 0.1 !important;
}
@media screen and (max-device-width: 415px) {
.video-content-title{
font-size: 51px;
}
}
</style>